import React from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { compose } from "recompose";
import { patientUpdateTriggerTemplateTypeSelector } from "../../redux/selectors";

const Filter = ({ currentFilter, setFilter, types }) => {
  const onChangeFilter = (event) => {
    setFilter(event.target.value);
  };

  return (
    <FormControl
      style={{
        textAlign: "center",
        width: "100%",
        overflow: "hidden",
        minHeight: "48px",
      }}
    >
      <Select
        value={currentFilter}
        onChange={onChangeFilter}
        autoWidth
        displayEmpty={true}
        style={{
          color: "white",
          fontSize: "20px",
          lineHeight: "1",
          letterSpacing: "0.25px",
          fontWeight: "700",
          padding: "0 0 0 24px",
          minHeight: "48px",
        }}
      >
        {types.map((filter) => (
          <MenuItem value={filter.id} id={filter.id} key={filter.id}>
            {filter.value}{" "}
            <KeyboardArrowDownIcon
              style={{
                color: "white",
                fontSize: "22px",
                margin: "0 0 -5px 5px",
              }}
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

const mapStateToProps = (state) => ({
  types: patientUpdateTriggerTemplateTypeSelector(state),
});

const enhance = compose(connect(mapStateToProps), injectIntl);
export default enhance(Filter);
